import { useMutation, useQuery } from "@tanstack/react-query";
import { createNewProject, getProjectDetails } from "../api/create-project-service";
export const useCreateProjectMutate = (queryParams) => {
    return useMutation({
        gcTime: 0,
        mutationFn: (createProjectRequest) => {
            return createNewProject(queryParams, createProjectRequest);
        },
        retry: false
    });
};
export const useGetProjectDetailsQuery = (projectId, queryParams) => {
    return useQuery({
        enabled: false,
        gcTime: 0,
        queryFn: async () => {
            return await getProjectDetails(projectId, queryParams);
        },
        queryKey: [
            "projectDetails",
            projectId,
            "downSelectPartyNumber" in queryParams ? queryParams.downSelectPartyNumber : null,
            "partyNumber" in queryParams ? queryParams.partyNumber : null
        ],
        retry: false
    });
};
